import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {
    ESTAGIO_EFETIVADO,
    ESTAGIO_NEGATIVADO,
} from '@/constants/pedidoEstagio.js';
import { generate } from '@/helpers/pdf';

const _getHead = () => ['FRANQUIA', 'LEADS EFETIVADOS', 'LEADS NEGATIVADOS'];

const _getBody = data => {
  const info = [];
  data.forEach(franquia => {
    let lead_efetivados = 0;
    let lead_negativados = 0;
    franquia.estagio.forEach(estagio => {
      if (estagio.id_estagio == ESTAGIO_EFETIVADO){
        lead_efetivados = estagio.total;
      } if(estagio.id_estagio == ESTAGIO_NEGATIVADO) {
        lead_negativados = estagio.total;
      }
    })
    info.push([franquia.nome_franquia, lead_efetivados, lead_negativados])
  });

  return info;
} 
const download = (data, meta) => {
  const infos = {
    head: [_getHead()],
    body: _getBody(data),
    title: 'Relatório Desempenho das Franquias',
    subTitle: meta.subTitle
  };
  console.log(infos)
    generate(infos, {
    fileName: meta.fileName
  });
 }
 export {
   download
 };


// WEBPACK FOOTER //
// ./src/pdf/DesempenhoFranquia.js